function Body(props) {
  return (
    <section className="page-section section-body">
      <div className="container p-0">
        <div className="message-body">
          <h4>
            <b className="mb-2">{props.title}</b>
          </h4>
          <p dangerouslySetInnerHTML={{__html:props.content}}/> 
        </div>
      </div>
    </section>
  );
}

export default Body;
